import { Button, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'

export const ButtonList = ({ list, onSelect, current }) => {
  const theme = useTheme()
  const handleClick = item => {
    onSelect?.(item)
  }

  return (
    <Grid container spacing={0}>
      {list?.map(item => (
        <Grid item xs={12} key={item.code}>
          <Button
            onClick={() => handleClick(item)}
            fullWidth
            sx={{ justifyContent: 'flex-start' }}
          >
            <Typography
              color={
                item.code === current?.code
                  ? theme.palette.buzzin.main
                  : 'textPrimary'
              }
            >
              {item.label}
            </Typography>
          </Button>
        </Grid>
      ))}
    </Grid>
  )
}
